import workspace from "./workspace";
import { getFilteredWorkspaceData } from "@/utils/workspaceOrgFilter";
import { useStore } from "@/store";


export const getAgents = async () => {
  const userOrg = useStore.userOrg();
  const  params =  { org_name: userOrg };

  try {
    return getFilteredWorkspaceData('/agents/', 'organization', { params });
  } catch (error) {
    console.error("Error fetching agents:", error);
    throw error;
  }
};


export const getAgentById = async (id) => {
  try {
    const response = await workspace.get(`/agents/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching agent with ID ${id}:`, error);
    throw error;
  }
};


export const createAgent = async (agentData) => {
  try {
    const response = await workspace.post(`/register-agent/`, agentData);
    return response.data;
  } catch (error) {
    console.error("Error creating agent:", error);
    throw error;
  }
};


export const updateAgent = async (id, agentData) => {
  try {
    const response = await workspace.put(`/agents/${id}/`, agentData);
    return response.data;
  } catch (error) {
    console.error(`Error updating agent with ID ${id}:`, error);
    throw error;
  }
};


export const deleteAgent = async (id) => {
  try {
    const response = await workspace.delete(`/agents/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting agent with ID ${id}:`, error);
    throw error;
  }
};
